export const formatThaiDate = (dateString?: string, lang?: 'th' | 'en'): string => {
    if (!dateString) return ''

    const date = new Date(dateString)
    if (isNaN(date.getTime())) return ''

    const resolvedLang = lang ?? 'th'
    const locale = resolvedLang === 'th' ? 'th-TH' : 'en-GB'

    return new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Asia/Bangkok',
    }).format(date)
}

export const MAX_FILE_SIZE = 31457280 // 30 mb

export const accept = '.png,.jpeg,.tiff,.pdf,.doc,.docx'
